import * as ActionTypes from '../constants/action_types'
import * as utils from './utils'
import moment from 'moment'

// -----------------------------------------------------------------------------
// API Calls

function fetchCalendar (startDate, endDate) {
  const lastWeek = getLastWeek()
  const body = {
    start_date: startDate,
    end_date: endDate,
    engagement_start_date: lastWeek.startDate,
    engagement_end_date: lastWeek.endDate
  }
  return utils.makeApiCall({
    url: '/api/insights/v1/calendar',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_CALENDAR,
    actionReceive: ActionTypes.RECEIVE_CALENDAR,
    actionFailure: ActionTypes.REQUEST_CALENDAR_FAILURE,
    authenticated: true
  })
}

function fetchCalendarExport () {
  const startDate = moment(new Date()).subtract(1, 'months').format('YYYY-MM-DD')
  const endDate = moment(new Date()).subtract(-2, 'months').format('YYYY-MM-DD')
  const body = {
    start_date: startDate,
    end_date: endDate
  }
  return utils.makeApiCall({
    url: '/api/insights/calendar/export',
    method: 'POST',
    body: body,
    actionRequest: ActionTypes.REQUEST_CALENDAR_EXPORT,
    actionReceive: ActionTypes.RECEIVE_CALENDAR_EXPORT,
    actionFailure: ActionTypes.REQUEST_CALENDAR_EXPORT_FAILURE,
    authenticated: true,
    actionProps: {
      filename: 'Calendar.xlsx'
    }
  })
}

function getLastWeek () {
  const today = new Date()
  const dayOfWeek = today.getDay()
  const daysToLastWeekMonday = dayOfWeek === 0 ? 7 + 6 : dayOfWeek + 6
  const lastWeekMonday = new Date(today);
  lastWeekMonday.setDate(today.getDate() - daysToLastWeekMonday)
  const lastWeekSunday = new Date(lastWeekMonday)
  lastWeekSunday.setDate(lastWeekMonday.getDate() + 6)
  return {
    startDate: lastWeekMonday.toISOString().split('T')[0],
    endDate: lastWeekSunday.toISOString().split('T')[0]
  }
}

// -----------------------------------------------------------------------------
// User invokable actions

export function fetchCalendarIfNeeded (startDate, endDate) {
  return (dispatch, getState) => {
    const state = (getState().calendar || {}).calendar
    if (utils.shouldFetch(state)) {
      return dispatch(fetchCalendar(startDate, endDate))
    }
    return Promise.resolve()
  }
}

export function fetchCalendarExportIfNeeded () {
  return dispatch => {
    return dispatch(fetchCalendarExport ())
  }
}